import { Step } from '@storebrand-digital/insurance-stepper';

export const stepsCorporate: Step[] = [
  {
    ariaLabel: 'Finn forsikringen',
    complete: false,
    id: '1',
    title: 'Finn forsikringen'
  },
  {
    ariaLabel: 'Kontaktperson i bedriften',
    complete: false,
    id: '2',
    title: 'Kontaktperson i bedriften'
  },
  {
    ariaLabel: 'Hva har skjedd?',
    complete: false,
    id: '3',
    title: 'Hva har skjedd?'
  },
  {
    ariaLabel: 'Fyll ut skadeskjemaet',
    complete: false,
    id: '4',
    title: 'Fyll ut skadeskjemaet'
  },
  {
    ariaLabel: 'Registrer saken',
    complete: false,
    id: '5',
    title: 'Registrer saken'
  }
];

export const stepsPrivate: Step[] = [
  {
    ariaLabel: 'Hva har skjedd?',
    complete: false,
    id: '1',
    title: 'Hva har skjedd?'
  },
  {
    ariaLabel: 'Velg forsikring',
    complete: false,
    id: '2',
    title: 'Velg forsikring'
  },
  {
    ariaLabel: 'Kontaktinformasjonen din',
    complete: false,
    id: '3',
    title: 'Kontaktinformasjonen din'
  },
  {
    ariaLabel: 'Fyll ut skadeskjemaet',
    complete: false,
    id: '4',
    title: 'Fyll ut skadeskjemaet'
  },
  {
    ariaLabel: 'Registrer saken',
    complete: false,
    id: '5',
    title: 'Registrer saken'
  }
];
